import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { ViewType } from '@this+that/models';
import log from 'loglevel';

import { PAGE_PATH_TO_VIEWTYPE_MAP } from './constants';
import { useEmailFilterResetEffect } from './useEmailFilterResetEffect';
import { useSmartDataFetch } from './useSmartDataFetch';
import { useIntegrationsStore } from '../../store';
import { useInboxAccountFilter } from '../useInboxAccountFilter';

export const usePageDataFetch = (specificViewType?: ViewType) => {
  const location = useLocation();
  const { fetchViewType } = useSmartDataFetch();
  const fetchViewTypeRef = useRef(fetchViewType);
  fetchViewTypeRef.current = fetchViewType;
  const { integrationAccounts } = useIntegrationsStore();
  const { fetchEmailFilters } = useInboxAccountFilter(integrationAccounts);

  useEmailFilterResetEffect(fetchEmailFilters);

  useEffect(() => {
    const fetchData = async () => {
      let viewTypeToFetch: ViewType | undefined;

      if (specificViewType) {
        viewTypeToFetch = specificViewType;
      } else {
        viewTypeToFetch = PAGE_PATH_TO_VIEWTYPE_MAP[location.pathname];
      }

      if (viewTypeToFetch) {
        try {
          await fetchViewTypeRef.current(viewTypeToFetch, fetchEmailFilters);
        } catch (error) {
          log.error(
            `Error fetching data for page ${location.pathname}:`,
            error,
          );
        }
      }
    };

    fetchData();
  }, [location.pathname, specificViewType, fetchEmailFilters]);
};
